import React, { useEffect, useState } from "react";
import Dynamic_FilterForm from "../../../../components/Dynamic_FilterForm";
import ExportToExcel from "../../../../components/ExportToExcel";
import SearchBar from "../../../../components/SearchBar";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { Accordion, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import Pagination from "../../../../components/Pagination";

const PayrollStatement = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Payroll Statement"));
    fetchIndexApi();
  }, []);

  const [branchOptions, setBranchOptions] = useState([]);
  const [shiftOptions, setShiftOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [payrollStatementData, setPayrollStatementData] = useState([]);

  const fetchIndexApi = async () => {
    let response;
    try {
      response = await GetServiceCaller(
        `${API_URL}rujul/finance/payroll-statements`
      );

      if (response?.status === 200) {
        const cleanedData = response?.data;
        const branchOpt = cleanedData?.branch?.map((o) => ({
          value: o.value,
          label: o.text,
        }));
        setBranchOptions(branchOpt);
        const shiftOpt = cleanedData?.shifts?.map((o) => ({
          value: o.value,
          label: o.text,
        }));
        setShiftOptions(shiftOpt);
        const monthOpt = cleanedData?.month?.map((o) => ({
          value: o.value,
          label: o.text,
        }));
        setMonthOptions(monthOpt);
        const empOpt = cleanedData?.employeeList?.map((o) => ({
          value: o.value,
          label: o.text,
        }));
        setEmployeeOptions(empOpt);
      }
    } catch (error) {
      console.error("Fetching Index Error", error);
    }
  };

  // Compute the current page's data
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(
    startIndex + itemsPerPage,
    payrollStatementData.length
  );
  const paginatedData = payrollStatementData.slice(startIndex, endIndex);

  const payrollSummary = Object.values(payrollStatementData).reduce(
    (acc, item) => {
      const [monthCode, monthDisplay] = item.MonthYear.split("|");

      // Initialize month group if it doesn't exist
      if (!acc.months[monthDisplay]) {
        acc.months[monthDisplay] = {
          monthCode,
          employeeCount: 0,
          totals: {
            Basic_DA: 0,
            HRA: 0,
            Gross_Salary: 0,
            Arrears: 0,
            CCA: 0,
            Conv_Allow: 0,
            Employer_NPS_Contribution: 0,
            Leave_Encash: 0,
            NPS_Deduction: 0,
            Net_Salary: 0,
            Night_Shift_Allowance: 0,
            Other_Allowance: 0,
            Other_Deduction: 0,
            PFDIR1: 0,
            PT: 0,
            Provident_Fund: 0,
            Recovery: 0,
            Ref_Bonus: 0,
            Spl_Allow: 0,
            TDS: 0,
            Total_CTC: 0,
            Training_Incentive: 0,
            V_Provident_Fund: 0,
          },
          records: [],
        };
      }

      const monthly = acc.months[monthDisplay];
      monthly.employeeCount++;
      monthly.records.push(item);

      // Payroll fields mapping
      const fields = {
        Basic_DA: "$Basic_&_DA",
        HRA: "$HRA",
        Gross_Salary: "$Gross_Salary",
        Arrears: "$Arrears",
        CCA: "$CCA",
        Conv_Allow: "$Conv_Allow",
        Employer_NPS_Contribution: "$Employer_NPS_Contribution",
        Leave_Encash: "$Leave_Encash",
        NPS_Deduction: "$NPS_Deduction",
        Net_Salary: "$Net_Salary",
        Night_Shift_Allowance: "$Night_Shift_Allowance",
        Other_Allowance: "$Other_Allowance",
        Other_Deduction: "$Other_Deduction",
        PFDIR1: "$PFDIR1",
        PT: "$PT",
        Provident_Fund: "$Provident_Fund",
        Recovery: "$Recovery",
        Ref_Bonus: "$Ref_Bonus",
        Spl_Allow: "$Spl_Allow",
        TDS: "$TDS",
        Total_CTC: "$Total_CTC",
        Training_Incentive: "$Training_Incentive",
        V_Provident_Fund: "$V__Provident_Fund",
      };

      // Add to monthly and grand totals
      for (const [key, field] of Object.entries(fields)) {
        const value = parseFloat(item[field]) || 0;
        monthly.totals[key] += value;
        acc.grandTotals[key] += value;
      }

      return acc;
    },
    {
      months: {},
      grandTotals: {
        Basic_DA: 0,
        HRA: 0,
        Gross_Salary: 0,
        Arrears: 0,
        CCA: 0,
        Conv_Allow: 0,
        Employer_NPS_Contribution: 0,
        Leave_Encash: 0,
        NPS_Deduction: 0,
        Net_Salary: 0,
        Night_Shift_Allowance: 0,
        Other_Allowance: 0,
        Other_Deduction: 0,
        PFDIR1: 0,
        PT: 0,
        Provident_Fund: 0,
        Recovery: 0,
        Ref_Bonus: 0,
        Spl_Allow: 0,
        TDS: 0,
        Total_CTC: 0,
        Training_Incentive: 0,
        V_Provident_Fund: 0,
      },
      totalEmployees: Object.values(payrollStatementData).length,
    }
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: payrollStatementData.length, label: "All" },
  ];

  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);
    setItemsPerPage(newRecordsPerPage);
    setCurrentPage(1); // Reset to first page when changing items per page
  };

  const [searchTerm, setSearchTerm] = useState("");
  const formDatas = [
    {
      name: "Branch",
      type: "Select",
      options: [...branchOptions],
    },
    {
      name: "Shift",
      type: "Select",
      options: [...shiftOptions],
    },
    {
      name: "Employee",
      type: "Select",
      options: [...employeeOptions],
    },
    {
      name: "Month",
      type: "IsMulti",
      options: [...monthOptions],
    },
    {
      name: "Show Approved Only",
      type: "Checkbox",
    },
  ];

  const [filterFormData, setFilterData] = useState([{ label: 'Branch', value: 2 }]);

  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e,
          },
        ];
      }
    });
  };

  const [apiStatus, setApiStatus] = useState(null); // null: initial, 'loading': fetching, 'success': loaded, 'error': failed

  const handleGetData = async () => {
    const monthID = filterFormData.find((o) => o.label === "Month")?.value;

    if (!monthID) {
      toast.error("Month field is required.");
      return;
    }

    setApiStatus('loading');
    setPayrollStatementData([]);
    setFormattedKeys(Object.values(columns))
    try {
      const response = await GetServiceCaller(
        `${API_URL}rujul/finance/payroll-statements-data?p_ContactID=${filterFormData.find((o) => o.label === "Employee")?.value || 0
        }&p_Month=${filterFormData.find((o) => o.label === "Month")?.value || 0
        }&p_ShiftID=${filterFormData.find((o) => o.label === "Shift")?.value || 0
        }&p_IsApproved=${filterFormData.find((o) => o.label === "Show Approved Only")?.value == true ?1:0 || 0
        }`
      );

      if (response?.status === 200) {
        setApiStatus('success');
        const cleanedGetData = response?.data?.data || [];
        setPayrollStatementData(cleanedGetData);
      } else {
        setApiStatus('error');
        toast.error("Failed to fetch data");
      }
    } catch (error) {
      console.error("Fetching Data Error", error);
      setApiStatus('error');
      toast.error("An error occurred while fetching data");
    }
  };

  const columns = {
    Branch: { key: "Branch", label: "Branch" },
    TXNDate: { key: "TXNDate", label: "TXNDate" },
    TXNName: { key: "TXNName", label: "TXNName" },
    Employee: { key: "Employee", label: "Employee" },
    IsApproved: { key: "IsApproved", label: "Approved" },
    Code: { key: "Code", label: "Code" },
    HRExecutive: { key: "HRExecutive", label: "Executive" },
    Shift: { key: "Shift", label: "Shift" },
    AbsentDays: { key: "AbsentDays", label: "Absent Days" },
  };

  const [formattedKeys, setFormattedKeys] = useState(Object.values(columns));

  useEffect(() => {
    if (payrollStatementData.length > 0) {
      const extractedKeys = [];

      Object.keys(payrollStatementData[0]).forEach((key) => {
        if (key.startsWith("$")) {
          const newKey = key.replace("$", "").replace(/_/g, " ");
          extractedKeys.push({ key: key, label: newKey });
        }
      });

      setFormattedKeys([...Object.values(columns), ...extractedKeys]);
    }
  }, [payrollStatementData]);

  const formatDataForExcel = (data) => {
    if (!data || data.length === 0) return [];

    const headers = formattedKeys.map(col => col.label);
    const rows = [];

    Object.entries(payrollSummary?.months || {}).forEach(([monthName, monthData]) => {
      const monthRow = {};

      formattedKeys.forEach(col => {
        if (col.key.startsWith("$")) {
          const total = monthData.records.reduce((sum, record) => {
            return sum + (parseFloat(record[col.key])) || 0;
          }, 0);
          monthRow[col.label] = total?.toFixed(2);
        } else if (col.key === "Branch") {
          monthRow[col.label] = monthName;
        } else if (col.key === "Employee") {
          monthRow[col.label] = monthData.employeeCount;
        } else {
          monthRow[col.label] = "-";
        }
      });

      rows.push(monthRow);

      monthData.records.forEach(record => {
        const detailRow = {};
        formattedKeys.forEach(col => {
          const value = record[col.key] || "-";
          if (col.key.includes("Date") && value !== "-") {
            detailRow[col.label] = moment(value).format("DD-MMM-YYYY");
          } else if (col.key.startsWith("$")) {
            detailRow[col.label] = parseFloat(value)?.toFixed(2);
          } else {
            detailRow[col.label] = value;
          }
        });
        rows.push(detailRow);
      });
    });

    if (payrollSummary?.grandTotals) {
      const grandTotalRow = {};
      formattedKeys.forEach(col => {
        if (col.key.startsWith("$")) {
          grandTotalRow[col.label] = payrollSummary.grandTotals[col.key.replace('$', '')]?.toFixed(2);
        } else if (col.key === "Branch") {
          grandTotalRow[col.label] = "Grand Total";
        } else if (col.key === "Employee") {
          grandTotalRow[col.label] = payrollSummary.totalEmployees;
        } else {
          grandTotalRow[col.label] = "-";
        }
      });
      rows.push(grandTotalRow);
    }

    return rows;
  };

  const [activeClientKey, setActiveClientKey] = useState(null);
  const [activeProjectKey, setActiveProjectKey] = useState({});

  const handleClientToggle = (clientKey) => {
    setActiveClientKey(activeClientKey === clientKey ? null : clientKey);
  };

  const handleProjectToggle = (clientIndex, projectKey) => {
    setActiveProjectKey((prev) => ({
      ...prev,
      [clientIndex]: prev[clientIndex] === projectKey ? null : projectKey,
    }));
  };

  const handleReset = () => {
    setFilterData([]);
    fetchIndexApi();
    setApiStatus(null);
    setFormattedKeys(Object.values(columns))
    setPayrollStatementData([]);
  };
const filterPayrollData = (payrollSummary, searchTerm) => {
  if (!searchTerm) return payrollSummary;

  const lowerSearch = searchTerm.toLowerCase();
  const filteredMonths = {};

  Object.entries(payrollSummary.months).forEach(([monthName, monthData]) => {
    // Check if month name matches search
    const monthMatches = monthName.toLowerCase().includes(lowerSearch);

    // Check if any employee records match search
    const matchingRecords = monthData.records.filter(record => 
      Object.entries(record).some(([key, value]) => {
        // Skip numeric fields if needed
        if (key.startsWith('$')) return false;
        return String(value).toLowerCase().includes(lowerSearch);
      })
    );

    // If month name matches or has matching records, include it
    if (monthMatches || matchingRecords.length > 0) {
      filteredMonths[monthName] = {
        ...monthData,
        records: monthMatches ? monthData.records : matchingRecords,
        employeeCount: monthMatches ? monthData.employeeCount : matchingRecords.length
      };
    }
  });

  // Recalculate grand totals
  const grandTotals = Object.values(filteredMonths).reduce((acc, month) => {
    Object.entries(month.totals).forEach(([key, value]) => {
      acc[key] = (acc[key] || 0) + value;
    });
    return acc;
  }, {});

  return {
    months: filteredMonths,
    grandTotals,
    totalEmployees: Object.values(filteredMonths).reduce((sum, month) => sum + month.employeeCount, 0)
  };
};

// Usage:
const filteredPayrollSummary = filterPayrollData(payrollSummary, searchTerm);  
  return (
    <div className="container-fluid" id="skill_section">
      <div className=" rounded bg-white" id="skill-table-area">
        <div className="d-flex justify-content-between">
          <div className="d-flex ">
            <div className="d-flex">
              <div className="me-1">
                <SearchBar
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                />
              </div>
            </div>
            <div className="dropdown">
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
              >
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="excel-btn"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-funnel-fill"></i>
                </button>
              </OverlayTrigger>

              <div>
                <Dynamic_FilterForm
                  formData={formDatas || []}
                  handleChange={handleChange}
                  handleReset={handleReset}
                  handleGetData={handleGetData}
                  filterFormData={filterFormData}
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end">
            <div className="me-1">
              <ExportToExcel
                data={formatDataForExcel(payrollStatementData)}
                filename="payrollStatement.csv"
              />
            </div>
          </div>
        </div>
        <div className="table-responsive">
          <Table striped bordered hover>
            <thead id="thcolor">
              <tr>
                {formattedKeys.map((col) => (
                  <OverlayTrigger
                    key={col.key}
                    placement="bottom"
                    overlay={<Tooltip id={`tooltip-${col.key}`}>{col.label}</Tooltip>}
                  >
                    <th
                      style={{
                        minWidth: col.key === "Branch" ? "130px" : "80px",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {col.label}
                    </th>
                  </OverlayTrigger>
                ))}
              </tr>
            </thead>
            <tbody>
              {apiStatus === 'loading' ? (
                <tr>
                  <td colSpan={formattedKeys.length} className="text-center py-4">
                    <div className="d-flex flex-column align-items-center">
                      <FaSpinner className="spinner mb-2" />
                      <span>Loading data...</span>
                    </div>
                  </td>
                </tr>
              ) : apiStatus === 'success' && payrollStatementData.length === 0 ? (
                <tr>
                  <td colSpan={formattedKeys.length} className="text-center py-4">
                    <div className="text-muted">No data available</div>
                  </td>
                </tr>
              ) : apiStatus === 'success' ? (
                <>
                  {Object.entries(filteredPayrollSummary?.months || {}).map(
                    ([monthName, monthData], monthIndex) => {
                      const totals = {};
                      formattedKeys.forEach((col) => {
                        if (col.key.startsWith("$")) {
                          totals[col.key] = monthData.records
                            .reduce((sum, record) => {
                              return sum + (parseFloat(record[col.key]) || 0);
                            }, 0)
                            .toFixed(2);
                        }
                      });

                      const isExpanded = activeClientKey === monthIndex.toString();

                      return (
                        <React.Fragment key={`month-${monthIndex}`}>
                          {/* Month summary row */}
                          <tr className="fw-bold bg-light">
                            {formattedKeys.map((col) => {
                              if (col.key.startsWith("$")) {
                                return (
                                  <td
                                    key={`total-${col.key}`}
                                    className="text-end"
                                    style={{ minWidth: '100px' }}
                                  >
                                    {parseFloat(totals[col.key]).toLocaleString('en-IN', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    })}
                                  </td>
                                );
                              }

                              if (col.key === "Branch") {
                                return (
                                  <td
                                    key={`month-${monthIndex}`}
                                    onClick={() => handleClientToggle(monthIndex.toString())}
                                    style={{
                                      cursor: "pointer",
                                      minWidth: '150px'
                                    }}
                                    className="fw-semibold text-dark"
                                  >
                                    <div className="d-flex align-items-center">
                                      <FontAwesomeIcon
                                        icon={isExpanded ? faChevronDown : faChevronRight}
                                        className="me-2"
                                      />
                                      <span className="flex-grow-1">{monthName}</span>
                                    </div>
                                  </td>
                                );
                              }

                              if (col.key === "Employee") {
                                return (
                                  <td
                                    key={`empcount-${col.key}`}
                                    style={{ minWidth: '80px', textAlign: 'center' }}
                                  >
                                    {monthData.employeeCount}
                                  </td>
                                );
                              }

                              return (
                                <td
                                  key={`empty-${col.key}`}
                                  style={{ minWidth: '80px' }}
                                >
                                  -
                                </td>
                              );
                            })}
                          </tr>

                          {/* Detailed rows */}
                          {isExpanded && monthData.records.map((data, subIndex) => (
                            <tr key={`detail-${monthIndex}-${subIndex}`}>
                              {formattedKeys.map((col) => {
                                const cellValue = data[col.key] || "-";
                                const isDateColumn = col.key.includes("Date");
                                const isNumericColumn = col.key.startsWith("$");

                                return (
                                  <td
                                    key={`${monthIndex}-${subIndex}-${col.key}`}
                                    style={{
                                      minWidth: col.key === "Branch" ? "150px" : "80px",
                                      maxWidth: "200px",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                    }}
                                    className={
                                      isNumericColumn
                                        ? "text-end"
                                        : isDateColumn
                                          ? "text-center"
                                          : col.key === "AbsentDays" ? "text-end" : ""
                                    }
                                    title={cellValue !== "-" ? String(cellValue) : ""}
                                  >
                                    {isDateColumn && cellValue !== "-"
                                      ? moment(cellValue).format("DD-MMM-YYYY")
                                      : isNumericColumn
                                        ? parseFloat(cellValue).toLocaleString('en-IN', {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2
                                        })
                                        : cellValue}
                                  </td>
                                );
                              })}
                            </tr>
                          ))}
                        </React.Fragment>
                      );
                    }
                  )}

                  {/* Grand Totals Row */}
                  <tr className="fw-bold text-white" style={{ backgroundColor: "#c3d6eb" }}>
                    {formattedKeys.map((col) => {
                      if (col.key.startsWith("$")) {
                        const grandTotal = payrollSummary?.grandTotals[col.key.replace('$', '')] || 0;
                        return (
                          <td
                            key={`grandtotal-${col.key}`}
                            className="text-end"
                            style={{ minWidth: '100px' }}
                          >
                            {parseFloat(grandTotal).toLocaleString('en-IN', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}
                          </td>
                        );
                      }

                      if (col.key === "Branch") {
                        return (
                          <td
                            key="grandtotal-label"
                            className="fw-bold"
                            style={{ minWidth: '150px' }}
                          >
                            Grand Total
                          </td>
                        );
                      }

                      if (col.key === "Employee") {
                        return (
                          <td
                            key="grandtotal-employees"
                            style={{ minWidth: '80px', textAlign: 'center' }}
                          >
                            {payrollSummary?.totalEmployees || 0}
                          </td>
                        );
                      }

                      return (
                        <td
                          key={`empty-grandtotal-${col.key}`}
                          style={{ minWidth: '80px' }}
                        >
                          -
                        </td>
                      );
                    })}
                  </tr>
                </>
              ) : apiStatus === 'error' ? (
                <tr>
                  <td colSpan={formattedKeys.length} className="text-center py-4">
                    <div className="text-danger">Error loading data</div>
                  </td>
                </tr>
              ) : (
                <tr>
                  <td colSpan={formattedKeys.length} className="text-center py-4">
                    <div className="text-muted">No Data Found</div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        {apiStatus === 'success' && payrollStatementData.length > 0 && (
          <div className="d-flex justify-content-between mb-3">
            <div>
              <span className="d-flex">
                Showing {(currentPage - 1) * itemsPerPage + 1} -{" "}
                {Math.min(
                  currentPage * itemsPerPage,
                  payrollStatementData.length
                )}{" "}
                of {payrollStatementData.length} <span className="ms-1">results</span>
                <select
                  value={itemsPerPage}
                  onChange={handleRecordsPerPage}
                  className="mx-2 form-select-sm"
                >
                  {recordsPerPageOption.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </span>
            </div>
            <div>
              <Pagination
                itemsPerPage={itemsPerPage}
                totalItems={payrollStatementData.length}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PayrollStatement;